import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/layout/Navigation';
import familyImg from '../assets/images/familylaw.webp'
const FamilyLawService = () => {
    return (
        <div className="font-sans">
        <Navigation />
        
        {/* Breadcrumb */}
        <div className="container mx-auto px-4 py-4 mt-16 text-center md:text-left">
            <div className="text-gray-500">
            <Link to="/" className="hover:text-indigo-600">Home</Link> {' > '}
            <Link to="/practice-areas" className="hover:text-indigo-600">Practice Area</Link> {' > '}
            <span className="text-indigo-600">Family Law</span>
            </div>
        </div>
        
        {/* Title */}
        <div className="container mx-auto px-4 pb-8 text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900">Family Law</h1>
        </div>
        
        {/* Banner Image */}
        <div className="container mx-auto px-4 mb-12">
            <div className="relative rounded-lg overflow-hidden">
            <img 
                src={familyImg} 
                alt="Family law - scales of justice and family silhouette" 
                className="w-full object-cover h-[400px]"
            />
            </div>
        </div>
        
        {/* Content Section */}
        <div className="container mx-auto px-4 py-8">
            <div className="max-w-4xl mx-auto space-y-8">
            <div className="space-y-6 text-gray-700 text-lg">
                <p>
                When it comes to family matters, having a reliable and experienced lawyer by your side is 
                crucial. In Rawalpindi and Islamabad, one name stands out among the rest – Wisdoms Law.
                </p>
                
                <p>
                As the best family lawyer in Islamabad and Rawalpindi, Wisdoms Law has earned a stellar reputation 
                for their expertise and dedication in handling a wide range of family law cases. With their 
                extensive knowledge of both Rawalpindi and Islamabad legal systems, they are well-equipped 
                to navigate through complex legal processes with ease.
                </p>
                
                <p>
                Whether you are facing issues related to divorce, child custody, property disputes, or any 
                other family-related matter, Wisdoms Law is committed to providing personalized 
                attention and tailored solutions to meet your specific needs. They understand that every 
                case is unique and requires a compassionate yet assertive approach.
                </p>
                
                <p>
                If you are searching for a reliable family lawyer in Rawalpindi or Islamabad who can provide 
                expert guidance and support during challenging times, look no further than Wisdoms Law. 
                Contact them today for a consultation and let them guide you through the legal 
                complexities while ensuring your best interests are protected every step of the way.
                </p>
            </div>
            
            <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">We specialize in the following areas:</h2>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-indigo-700 mb-3">Divorce & Khula</h3>
                    <p className="text-gray-600">
                    Expert representation in all types of divorce proceedings, including talaq (divorce initiated by husband) 
                    and khula (divorce initiated by wife) under Islamic and Pakistani law, ensuring your rights are protected.
                    </p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-indigo-700 mb-3">Child Custody</h3>
                    <p className="text-gray-600">
                    Skilled advocacy for your parental rights and the best interests of your children in custody (hizanat) 
                    matters, including physical custody, visitation rights, and decision-making authority.
                    </p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-indigo-700 mb-3">Maintenance (Nafaqah)</h3>
                    <p className="text-gray-600">
                    Assistance in securing appropriate maintenance payments for spouses and children, ensuring 
                    financial support obligations are met according to Pakistani family laws.
                    </p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-indigo-700 mb-3">Marriage Registration</h3>
                    <p className="text-gray-600">
                    Guidance through the process of nikah registration, ensuring compliance with legal requirements 
                    and protection of your rights through properly documented marriage contracts.
                    </p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-indigo-700 mb-3">Inheritance Disputes</h3>
                    <p className="text-gray-600">
                    Expert resolution of inheritance matters according to Islamic succession laws and 
                    Pakistani legislation, protecting your rightful share in family assets and property.
                    </p>
                </div>
                
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <h3 className="text-xl font-semibold text-indigo-700 mb-3">Guardianship</h3>
                    <p className="text-gray-600">
                    Legal assistance in establishing guardianship for minors and incapacitated individuals, 
                    ensuring proper care and protection of their personal and financial interests.
                    </p>
                </div>
                </div>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-lg border border-gray-200">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Why Choose Wisdoms Law for Family Law Matters?</h2>
                
                <ul className="space-y-4 mt-4">
                <li className="flex items-start">
                    <svg className="w-6 h-6 text-indigo-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-700">
                    <strong className="font-semibold">Expertise in Islamic and Pakistani Family Laws:</strong> Our team has in-depth knowledge of both religious and statutory laws governing family matters in Islamabad and Rawalpindi.
                    </span>
                </li>
                
                <li className="flex items-start">
                    <svg className="w-6 h-6 text-indigo-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-700">
                    <strong className="font-semibold">Compassionate Representation:</strong> We understand the emotional challenges of family disputes and provide supportive guidance throughout the legal process.
                    </span>
                </li>
                
                <li className="flex items-start">
                    <svg className="w-6 h-6 text-indigo-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-700">
                    <strong className="font-semibold">Proven Track Record:</strong> Our firm has successfully handled numerous family law cases across Islamabad and Rawalpindi courts at all levels.
                    </span>
                </li>
                
                <li className="flex items-start">
                    <svg className="w-6 h-6 text-indigo-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-700">
                    <strong className="font-semibold">Personalized Solutions:</strong> We recognize that each family situation is unique and tailor our legal strategies to your specific circumstances and goals.
                    </span>
                </li>
                
                <li className="flex items-start">
                    <svg className="w-6 h-6 text-indigo-600 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-gray-700">
                    <strong className="font-semibold">Client-Centered Approach:</strong> We prioritize clear communication, accessibility, and ensuring you fully understand your legal options and their implications.
                    </span>
                </li>
                </ul>
            </div>
            
            {/* CTA Section */}
            <div className="bg-indigo-50 p-8 rounded-lg border border-indigo-100 text-center">
                <h2 className="text-2xl font-bold text-indigo-800 mb-4">Need Help With Family Law Matters?</h2>
                <p className="text-indigo-600 mb-6">
                Contact Wisdoms Law today to schedule a confidential consultation with our experienced family law team.
                </p>
                <div className="flex flex-col sm:flex-row justify-center gap-4">
                <Link 
                    to="/contact" 
                    className="bg-indigo-600 text-white px-6 py-3 rounded-md font-medium hover:bg-indigo-700 transition-colors"
                >
                    Contact Us
                </Link>
                <a 
                    href="tel:+923001234567" 
                    className="bg-white text-indigo-600 border border-indigo-600 px-6 py-3 rounded-md font-medium hover:bg-indigo-50 transition-colors"
                >
                    Call Now: +92 300 123 4567
                </a>
                </div>
            </div>
            </div>
        </div>
        
        {/* Whatsapp Float Button */}
        <div className="fixed bottom-6 right-6 z-50">
            <a 
            href="https://wa.me/923329754400" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="bg-green-500 hover:bg-green-600 text-white p-3 rounded-full shadow-lg flex items-center justify-center w-16 h-16"
            >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="currentColor" viewBox="0 0 24 24">
                <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
            </svg>
            </a>
        </div>
        </div>
    );
};

export default FamilyLawService;